import { thaiMoment } from 'helpers';
import React, { useState } from 'react';
import { CURRENT_TCAS_YEAR } from 'constants/school-year';
import cn from 'classnames';
import moment from 'moment';

// Components
import Round41 from './Round41';
import Round42 from './Round42';
import { EMPTY_ROUND } from '../round-data';

// Data
import enabled from 'data/enabled';

const Round4 = ({ enrollment }) => {

  const [active, setActive] = useState(false);

  const { loading, loadFailed, timestamp } = enrollment;
  const { offers: offersR41, replies: repliesR41, offerCount: offerCountR41 } = enrollment.byType[`41_${CURRENT_TCAS_YEAR}`] || EMPTY_ROUND;
  const { offers: offersR42, replies: repliesR42, offerCount: offerCountR42 } = enrollment.byType[`42_${CURRENT_TCAS_YEAR}`] || EMPTY_ROUND;
  const timestampR41 = timestamp;
  const timestampR42 = timestamp;

  const r41Expired = moment(timestampR41).isAfter(enabled.round41.reply_end);
  const r42Expired = moment(timestampR42).isAfter(enabled.round42.reply_end);

  return (
    <div className={cn('r-4', { active })}>
      <header onClick={() => setActive((_active) => !_active)}>
        <b><small>{'รอบ'}</small>4</b>
        <h3>
          Direct Admission
          <small>{moment(timestampR41).isBefore(enabled.round41.reply_start)
            ? `${thaiMoment(enabled.round41.reply_start).format('D MMM')} - ${thaiMoment(enabled.round42.reply_end).format('D MMM')} ${thaiMoment(enabled.round42.reply_end).add(543, 'years').format('YY')}`
            : (!offerCountR41 && !offerCountR42)
              ? 'ท่านไม่ได้สมัครในรอบนี้'
              : (r41Expired && offersR42.length)
                ? `ผ่านการคัดเลือก ${offersR42.length} สาขาวิชา`
                : offersR41.length
                  ? `ผ่านการคัดเลือก ${offersR41.length} สาขาวิชา`
                  : 'ท่านไม่ผ่านการคัดเลือกในรอบนี้'}</small>
        </h3>
        <i className="i-down"></i>
      </header>
      <div className="content">
        <Round41
          expired={r41Expired}
          loading={loading}
          loadFailed={loadFailed}
          offerCount={offerCountR41}
          offers={offersR41}
          replies={repliesR41}
          timestamp={timestampR41} />
        <Round42
          expired={r42Expired}
          loading={loading}
          loadFailed={loadFailed}
          offerCount={offerCountR42}
          offers={offersR42}
          replies={repliesR42}
          timestamp={timestampR42} />
      </div>
    </div>
  )
}

export default Round4;